export function isBKJChangeEventType(event) {
    if (typeof event !== 'undefined' &&
        typeof event.target !== 'undefined' &&
        typeof event.target.name !== 'undefined' &&
        typeof event.target.value !== 'undefined')
        return true;
    return false;
}
export function isArray(value) {
    return Array.isArray(value);
}
export function isNumber(arg) {
    return typeof arg === 'number' && Number.isInteger(arg);
}
export function isString(value) {
    return typeof value === 'string';
}
export function isBoolean(value) {
    return typeof value === 'boolean';
}
export function isFormValidationErrorDisplayed(error) {
    if (isArray(error) && error.length === 0)
        return false;
    if (isArray(error) && error.length >= 1 && error.every((msg) => isString(msg) && msg !== ''))
        return true;
    if (isBoolean(error))
        return error;
    if (isString(error) && error !== '')
        return true;
    if (isString(error) && error === '')
        return false;
    return false;
}
//# sourceMappingURL=common.types.js.map